import { StaticDataRouteOption, useRouter } from '@tanstack/react-router';
import { array, option, string } from 'fp-ts';
import { EnterprisePaths, enterpriseRoutePrefix } from './types';

type GuideLink = Pick<StaticDataRouteOption, 'guideLink'>;
type GuideLinkContext = keyof Extract<GuideLink['guideLink'], object>;

interface PotentialGuideLinkRoute {
    staticData: GuideLink;
}

const filterMapGuideLinks = array.filterMap((route: PotentialGuideLinkRoute) =>
    option.fromNullable(route.staticData.guideLink)
);

/** Match on an EnterprisePath, and return the frst GuideLink from the matched route's static data */
export const useMatchedGuideLink = (
    enterpriseLink: EnterprisePaths | null | undefined,
    guideContext: GuideLinkContext = 'enterprise'
) => {
    const router = useRouter();

    if (!enterpriseLink) {
        return null;
    }

    const matchedRoutes = router.matchRoutes(
        router.buildLocation({
            to: `${enterpriseRoutePrefix}${enterpriseLink}`,
        })
    );

    if (!matchedRoutes || matchedRoutes.length === 0) {
        return null;
    }

    const guideLinkRoutes = filterMapGuideLinks(matchedRoutes);

    if (guideLinkRoutes.length === 0) {
        return null;
    }

    const guideLink = guideLinkRoutes[0];
    return string.isString(guideLink) ? guideLink : guideLink[guideContext];
};
